// app/javascript/projects/components/ProjectsDisplay.jsx
import React from 'react';
import {MenuItem, DropdownButton} from 'ui'
import ColorConstants from 'constants/ColorConstants'
import UserCircle from './UserCircle'
import { useHistory } from 'react-router-dom'
import { useSignOut } from 'hooks/auth/mutations'

function AccountFooter({ initials, name }) {
  const signOut = useSignOut();
  const history = useHistory();

  const handleLogout = () => {
    signOut.mutate();
  };

  return (
    <div style={{borderTop:"1px solid lightGray", padding:"0px 10px 10px 10px", backgroundColor:ColorConstants.BLACK}}>
      <DropdownButton style={{width:"100%", padding:0, margin:0}} variant="link" noCaret dropup title={
          <div style={{width:"100%"}}>
            <div style={{float:"left"}}>
              <UserCircle initials={initials}/>
            </div>
            <div style={{float:"left", marginBottom:0, marginTop:20, marginLeft:10, color:ColorConstants.ULTRA_LIGHT_GREY, width:150}}>
              <p style={{textAlign:"left", whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"}}>{name}</p>
            </div>
            <div style={{clear:"both"}}/>
          </div>
        } id="accountDropUp">
        <MenuItem eventKey="1" onClick={() => history.push('/users')}>Account</MenuItem>
        <MenuItem onClick={handleLogout} eventKey="2">Log Out</MenuItem>
      </DropdownButton>
    </div>
  );
}

export default AccountFooter;